import tinyColor from "tinycolor2"
import ld from "lodash"
import jq from "jquery"

// TODO: Refactor to new SkinProvider

const transformObject = (object, transformKey = (k) => k, transformValue = (v) => v, level = 0) => {
  let keys = ld.keys(object)

  return ld.reduce(
    keys,

    (transformedObject, key) => {
      let value = object[key]
      let transformedKey = transformKey(key, value, level)

      let transformedValue = ld.isPlainObject(value)
        ? transformObject(value, transformKey, transformValue, level + 1)
        : transformValue(value, level)

      return {
        ...transformedObject,
        [transformedKey]: transformedValue,
      }
    },
    {},
  )
}

const mapToJss = (skinObject) => {
  let classNames = []

  let transformedObject = transformObject(skinObject, (k, v, level) => {
    if (ld.startsWith(k, "m_")) {
      let className = k.replace(/m_/, "")
      classNames.push(className)
      return `&$${className}`
    }

    if (ld.startsWith(k, "pm_")) {
      return k.replace(/pm_/, "&:")
    }

    if (ld.isPlainObject(v) && level > 0) {
      classNames.push(k)
      return `& $${k}`
    }

    return k
  })

  return ld.reduce(
    classNames,

    (object, className) => {
      return {
        ...object,
        [className]: {},
      }
    },

    transformedObject,
  )
}

const mergeWithDefault = ld.curry((hierarchySkinObject, defaultObject, skinObject) => {
  let keys = ld.keys(defaultObject)

  return ld.reduce(
    keys,

    (mergedObject, key) => {
      let defaultValue = defaultObject[key]
      let skinValue = skinObject[key]
      let hierarchySkinValue = hierarchySkinObject[key]

      let mergedValue = ld.isPlainObject(defaultValue)
        ? mergeWithDefault(hierarchySkinValue || {}, defaultValue, skinValue || {})
        : hierarchySkinValue == null
        ? skinValue == null
          ? defaultValue
          : skinValue
        : hierarchySkinValue

      return {
        ...mergedObject,
        [key]: mergedValue,
      }
    },

    defaultObject,
  )
})

export const toJss = (skinObject, defaultObject, hierarchySkinObject = {}) => {
  return ld.flowRight([mapToJss, mergeWithDefault(hierarchySkinObject, defaultObject)])(skinObject)
}

export const setVariables = (variables, skinObject) => {
  let variableKeys = ld.keys(variables)

  return transformObject(
    skinObject,
    (k) => k,

    (v) => {
      let variableKeyIndex = variableKeys.indexOf(v)

      return variableKeyIndex !== -1 ? variables[variableKeys[variableKeyIndex]] : v
    },
  )
}

export const darken = ld.curry((percent, value) => {
  return tinyColor(value).darken(percent).toString()
})

export const lighten = ld.curry((percent, value) => {
  return tinyColor(value).lighten(percent).toString()
})
